import { render, staticRenderFns } from "./index.vue?vue&type=template&id=295a3650&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=295a3650&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295a3650",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('295a3650')) {
      api.createRecord('295a3650', component.options)
    } else {
      api.reload('295a3650', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=295a3650&scoped=true", function () {
      api.rerender('295a3650', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qualityService/holidayConfiguration/index.vue"
export default component.exports